import { useEffect, useMemo, useState } from "react"
import { Link } from 'react-router-dom'
import { Button, Table, Space, DatePicker, message} from 'antd'
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'
import moment from "moment"
import { axiosTable } from "../../tool/axios"
import {  SelectStores } from "../../component/common/Selects"
import getPermission from '../../js/permission'

const { Column } = Table

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    // showSizeChanger: false
}

export default function () {
    const permission: string[] = useMemo(() => {
        console.log(getPermission()) // ['查询', '查看', '添加', '编辑']
        return getPermission()
    }, [window.location.pathname])

    const [fetchOtherParams, setFetchOtherParams] = useState({
        store_id: undefined,
        order_date:undefined,
    })
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        // showSizeChanger: false
    })
    const [data, setData] = useState<any>([])
    const [loading,setLoading] = useState<boolean>(false)

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])
   
    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current
        
        let params: any = { ...fetchOtherParams }
        params.store_id = params.store_id ? params.store_id : ''
        params.order_date = params.order_date ? moment(params.order_date).format('YYYY-MM-DD') : ''
        axiosTable.get('/cooking/purchase/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }
            setLoading(false)
        })
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1
        fetch({ pagination: p, fetchOtherParams })
    }

    return (<div className="common-page">
        <BreadCrumb position={['膳食中心', '食材采购列表']} />
        <div className="common-top-form">
            <div className="clear">
                <span style={{padding:'0 10px'}}>当前门店：</span>
                <SelectStores
                    value={fetchOtherParams.store_id}
                    onChange={(val: any) => {
                        setFetchOtherParams({
                            ...fetchOtherParams,
                            store_id: val
                        })
                    }}
                ></SelectStores>
                <span style={{padding:'0 10px'}}>下单日期：</span>
                <DatePicker
                    value={fetchOtherParams.order_date}
                    style={{marginRight:12,marginBottom:12 }} 
                    onChange={(val: any) => {
                        setFetchOtherParams({
                            ...fetchOtherParams,
                            order_date: val
                        })
                    }} 
                />
                {/* {permission.includes('查询') && <Button 
                    style={{marginRight:12,marginBottom:12 }} 
                    className="search-btn fl" 
                    icon={<SearchOutlined />} 
                    onClick={handleSearch}>查询</Button>}  */}
                <Button
                    type="primary"
                    style={{marginRight:12,marginBottom:12 }}
                    onClick={handleSearch}>查询</Button>
            </div>
        </div>
        <div className="common-main">
            <Table loading={loading} 
                dataSource={data}
                bordered={true} 
                rowKey="purchase_id" 
                pagination={pagination} 
                onChange={handleTableChange}>
                <Column title="下单日期"  dataIndex="order_date" key="order_date" />
                <Column title="门店"  dataIndex="store_name" key="store_name" />
                <Column title="食材订单号"  dataIndex="food_order_code" key="food_order_code" />
                <Column  title="状态" dataIndex="status" key="status" 
                    render={(text, record: any) => {
                        const { status } = record
                        if(status == 1) {
                            return '已下单'
                        } else {
                            return '--'
                        }
                    }}
                />
                <Column title="食材总价"  dataIndex="food_total_amount" key="food_total_amount" />
                <Column  title="下单人" dataIndex="create_user_name" key="create_user_name" />
                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        const { purchase_id, store_name } = record
                        return (<Space size="middle">
                            {/* {permission.includes('编辑') &&
                            <Button onClick={() => {
                               
                            }} >查看详情</Button>} */}
                            <Link to={{pathname: '/food_purchase_detail', state: { purchase_id, store_name }}}>查看详情</Link>
                        </Space>)
                    }}
                />
            </Table>
        </div>
    </div>)
}